'use strict';

module.exports = {
  errors: {
    PATTERN_MISSING: 'A valid pattern must be provided',
    INVALID_ELEMENT: 'A valid HTML input or textarea element must be provided'
  }
};
